import { useGetMusicsApiV1Suspense } from "@/api/__generated__/api.schema";
import { externalUrls } from "@/constants/url";
import { invariant } from "@/utils/invariant";
import { COUNT_PER_PAGE } from "./use-musics";

interface UseMusicProps {
  assetId?: string | null;
}

export function useMusic({ assetId }: UseMusicProps) {
  const {
    data: {
      data: { items: musics },
    },
  } = useGetMusicsApiV1Suspense({
    limit: COUNT_PER_PAGE,
  });

  const music = musics.find((music) => music.assetId === assetId);

  if (assetId == null) {
    return null;
  }

  invariant(music != null, "Music not found");

  return {
    ...music,
    title: music.title.en,
    thumbnail: `${externalUrls.MUSIC_RESOURCE_BASE_URL}/${music.isrc}.avif`,
  };
}
